var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"settings-header"},[_c('h1',{staticClass:"page-title font_regular font_600 text_20"},[_vm._t("default"),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.headerTitle))])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }